import React, { useState } from 'react';
import { Tooltip } from 'reactstrap';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import _ from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAward, faHome, faUndoAlt, faQrcode } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import { numStr, t, translateDate } from '../common/Translate';
import MeetingTag from '../Calendar/MeetingTag';
import Timer from '../common/Timer';
import { useRecordRow } from '../../hooks/useForm/useRecord';
import { currencySign } from '../../Utils/currencySign';

export default function ({ record, origin, queries, currentTab }) {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggle = () => setTooltipOpen(!tooltipOpen);
  const {
    recordId,
    refHexaId,
    brandName,
    modelName,
    mileage,
    registration,
    expertiseStartAt,
    expertiseEndedAt,
    entryStockDate,
    statusCarcheck,
    formSource,
    buyerFullName,
    concessionName,
    recordTypeId,
    coverage,
    startTime,
    finishTime,
    firstRegistrationDate,
    salesCreatedAt,
    salesEndedAt,
    countOffer,
    b2cMarketValue,
    mcclbp,
    bestSaleOfferAmount,
    rplCoverageRequest,
    currentWinner,
    carProfile,
    sourceLabel,
    purchaseOrder,
    displayOnlyWinnersInfo,
    hideMerchantInfo,
    nrmStatusLabel,
    nrmRecordId,
    originId,
  } = record;
  const { blur } = useRecordRow({ purchaseOrder, displayOnlyWinnersInfo, hideMerchantInfo });
  const selectedPos = useSelector((state) => state.recordList.selectedPos);

  const history = useHistory();
  const handleClick = () => {
    history.push(`/files/${record.recordId}`, { origin, queries });
  };
  let tooltipInfo = {};
  if ([10, 12, 13, 14].includes(originId) && origin !== 'search') {
    tooltipInfo.icon = faAward;
    tooltipInfo.label = 'nrmFile';
  } else if (originId === 11) {
    tooltipInfo.icon = faHome;
    tooltipInfo.label = 'hbsNrmFile';
  } else if (formSource === 'clic2sell') {
    tooltipInfo.icon = faHome;
    tooltipInfo.label = 'hbsFile';
  } else if (formSource === 'clic2buy') {
    tooltipInfo.icon = faQrcode;
    tooltipInfo.label = 'clic2buyFile';
  } else if (recordTypeId === 2) {
    tooltipInfo.icon = faUndoAlt;
    tooltipInfo.label = 'counterAppraisalFile';
  } else if (coverage) {
    tooltipInfo.icon = faAward;
    tooltipInfo.label = 'guaranteedPriceLabel';
  } else {
    tooltipInfo = false;
  }

  let rowContent = null;
  if (currentTab === 'supervisorCoverageRequest') {
    rowContent = (
      <tr onClick={handleClick}>
        <td>
          {tooltipInfo && (
            <>
              <FontAwesomeIcon icon={tooltipInfo.icon} size="1x" id={`tooltip-${recordId}`} className="hbs-icon" />
              <Tooltip
                placement="top"
                isOpen={tooltipOpen}
                target={`tooltip-${recordId}`}
                toggle={toggle}
                className="my-tooltip"
              >
                {t(tooltipInfo.label)}
              </Tooltip>
            </>
          )}
        </td>
        <td>{refHexaId}</td>
        <td>{brandName}</td>
        <td>{modelName}</td>
        <td>{translateDate(firstRegistrationDate, 'YYYY')}</td>
        <td style={{ minWidth: '80px' }}>{numStr(mileage)}</td>
        <td>{`${translateDate(salesCreatedAt, 'DD.MM.YYYY HH:mm')}`}</td>
        <td>
          <Timer salesEndedAt={salesEndedAt} />
        </td>
        <td>{countOffer}</td>
        <td>
          {(() => {
            if (b2cMarketValue && b2cMarketValue > 0) {
              return currencySign(numStr(b2cMarketValue));
            }
            if (mcclbp && mcclbp > 0) {
              return currencySign(numStr(mcclbp));
            }
            return '';
          })()}
        </td>
        <td>{bestSaleOfferAmount > 0 && currencySign(numStr(bestSaleOfferAmount))}</td>
        <td>{(rplCoverageRequest > 0 && `${rplCoverageRequest} %`) || ''}</td>

        <td>{!blur && currentWinner}</td>
        <td>{carProfile}</td>
      </tr>
    );
  } else if (['supervisorAwaiting', 'supervisorOngoingAppraisal'].includes(currentTab)) {
    rowContent = (
      <tr onClick={handleClick}>
        <td>
          {tooltipInfo && (
            <>
              <FontAwesomeIcon icon={tooltipInfo.icon} size="1x" id={`tooltip-${recordId}`} className="hbs-icon" />
              <Tooltip
                placement="top"
                isOpen={tooltipOpen}
                target={`tooltip-${recordId}`}
                toggle={toggle}
                className="my-tooltip"
              >
                {t(tooltipInfo.label)}
              </Tooltip>
            </>
          )}
        </td>
        <td>{`${translateDate(_.get(expertiseStartAt, 'date', null), 'DD.MM.YYYY HH:mm')}`}</td>
        <td>{refHexaId}</td>
        <td>{sourceLabel}</td>
        {currentTab === 'supervisorOngoingAppraisal' && (
          <td>
            <MeetingTag code={statusCarcheck} />
          </td>
        )}
        {currentTab !== 'supervisorOngoingAppraisal' && <td>{carProfile ? carProfile.toUpperCase() : ''}</td>}
        {currentTab === 'supervisorAwaiting' && (
          <td>
            <Timer
              expertiseEndedAt={_.get(expertiseEndedAt, 'date', null)}
              startTime={startTime}
              finishTime={finishTime}
            />
          </td>
        )}
        <td>{b2cMarketValue >= 0 && currencySign(numStr(b2cMarketValue))}</td>
        <td>{registration}</td>
        <td>{`${brandName} ${modelName} ${translateDate(_.get(record, 'registrationDate.date', ''), 'YYYY')}`}</td>
        {origin === 'supervision' && (
          <>
            <td>{buyerFullName}</td>
            <td>{concessionName}</td>
          </>
        )}
      </tr>
    );
  } else if (
    [
      'onGoingNrm',
      'pricingInProgressNrm',
      'guaranteeActivatedNrm',
      'waitingCounterInspectionNrm',
      'finalizedNrm',
      'abandonedNrm',
    ].includes(currentTab)
  ) {
    rowContent = (
      <tr onClick={handleClick}>
        <td>
          {tooltipInfo && (
            <>
              <FontAwesomeIcon icon={tooltipInfo.icon} size="1x" id={`tooltip-${recordId}`} className="hbs-icon" />
              <Tooltip
                placement="top"
                isOpen={tooltipOpen}
                target={`tooltip-${recordId}`}
                toggle={toggle}
                className="my-tooltip"
              >
                {t(tooltipInfo.label)}
              </Tooltip>
            </>
          )}
        </td>
        <td>{refHexaId}</td>
        {!['onGoingNrm', 'pricingInProgressNrm'].includes(currentTab) && <td>{nrmRecordId}</td>}

        <td>{`${brandName} ${modelName} ${translateDate(_.get(record, 'registrationDate.date', ''), 'YYYY')}`}</td>
        <td style={{ minWidth: '80px' }}>{numStr(mileage)}</td>
        <td>{registration}</td>
        <td>{`${translateDate(_.get(expertiseStartAt, 'date', null), 'DD.MM.YYYY HH:mm')}`}</td>
        {!['onGoingNrm', 'pricingInProgressNrm'].includes(currentTab) && <td>{t(nrmStatusLabel)}</td>}
        <td>{buyerFullName}</td>
        <td>{concessionName}</td>
      </tr>
    );
  } else {
    rowContent = (
      <tr onClick={handleClick}>
        <td>
          {tooltipInfo && (
            <>
              <FontAwesomeIcon icon={tooltipInfo.icon} size="1x" id={`tooltip-${recordId}`} className="hbs-icon" />
              <Tooltip
                placement="top"
                isOpen={tooltipOpen}
                target={`tooltip-${recordId}`}
                toggle={toggle}
                className="my-tooltip"
              >
                {t(tooltipInfo.label)}
              </Tooltip>
            </>
          )}
        </td>
        <td>{refHexaId}</td>
        {currentTab === 'buyerAwaitingPricing' && (
          <td>
            <Timer
              expertiseEndedAt={_.get(expertiseEndedAt, 'date', null)}
              startTime={startTime}
              finishTime={finishTime}
            />
          </td>
        )}
        <td>{brandName}</td>
        <td>{modelName}</td>
        <td>{translateDate(_.get(record, 'registrationDate.date', ''), 'YYYY')}</td>
        <td style={{ minWidth: '80px' }}>{numStr(mileage)}</td>
        <td>{registration}</td>
        <td>{`${translateDate(_.get(expertiseStartAt, 'date', null), 'DD.MM.YYYY HH:mm')}`}</td>
        {selectedPos === 'privatePos' && <td>{entryStockDate ? moment(entryStockDate).format('DD.MM.YYYY') : ''}</td>}
        <td>
          <MeetingTag code={statusCarcheck} />
        </td>
      </tr>
    );
  }
  return rowContent;
}
